export default class VideoLoad {
  constructor() {
    this.$video = $('.main-video');
  }

  video() {
    if (this.$video.length) {
      this.$video[0].play();
    }
  }

  init() {
    this.video();
  }
}
